/*
 * @Date: 2023-11-14 13:54:29
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-14 16:51:12
 * @FilePath: /ckb-mall-web/src/container/home/modules/GoodsBanner/index.tsx
 * @Description:
 * @Author: lihwang
 */
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper/modules';
import Zuoleft1 from '@/common/icons/Zuoleft1';
import Zuoleft2 from '@/common/icons/Zuoleft2';
import { BannerRespDTO } from '@/service/market';
import { urlAddChannel } from '@/utils';
import styles from './index.module.scss';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/virtual';
interface BannerProps {
    goodsData: BannerRespDTO[];
}
interface SwiperRefProps {
    slideNext: () => void;
    slidePrev: () => void;
}
const iconStyle = {
    cursor: 'pointer'
};
const GoodsBanner: React.FC<BannerProps> = ({ goodsData }) => {
    const swiperRef = React.useRef<SwiperRefProps>();
    const goActivity = (jumpUrl?: string) => {
        if (jumpUrl) {
            // window.open(jumpUrl);
            window.open(urlAddChannel(jumpUrl));
        }
    };
    return (
        <div className={styles.container}>
            {goodsData.length > 4 ? (
                <>
                    <div
                        className={styles.slideLeft}
                        onClick={() => swiperRef.current?.slidePrev()}
                    >
                        <Zuoleft1 fontSize={40} style={iconStyle} />
                    </div>
                    <div
                        className={styles.slideRight}
                        onClick={() => swiperRef.current?.slideNext()}
                    >
                        <Zuoleft2 fontSize={40} style={iconStyle} />
                    </div>
                </>
            ) : null}
            {/** 条目达到8个支持虚拟滚动 */}
            {goodsData.length > 7 ? (
                <Swiper
                    className={styles.swiper}
                    virtual
                    modules={[Virtual]}
                    spaceBetween={16}
                    slidesPerView={4}
                    loop
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                >
                    {goodsData.map((item, index) => (
                        <SwiperSlide key={index} virtualIndex={index}>
                            <img
                                className={styles.img}
                                src={item.picUrl}
                                alt={item.title}
                                onClick={() => goActivity(item.jumpUrl)}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <Swiper
                    className={styles.swiper}
                    spaceBetween={16}
                    slidesPerView={4}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                >
                    {goodsData.map((item, index) => (
                        <SwiperSlide key={index}>
                            <img
                                className={styles.img}
                                src={item.picUrl}
                                alt={item.title}
                                onClick={() => goActivity(item.jumpUrl)}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    );
};
export default GoodsBanner;
